import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-translate-whatsapp-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [isTranslator]="true"
      [templateType]="templateType"
      templateBasePath="/translate-whatsapp-template/"
      channelLabel="Whatsapp"
      namePlaceholder="Enter whatsapp name"
      emptyMessage="No whatsapp found!"
      heartbeatType="whatsapp"
      [showMetaSection]="true"
      [showTranslateButton]="false" />
  `
})
export class TranslateWhatsappTemplateComponent {
  protected readonly templateType = TypeEnum.WHATSAPP;
}
